import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";
import { history } from "nexia_mobile/history";

const Camera = ({ model, isDetailed }) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    <DeviceControlButton
      buttonLabel="Show Video"
      onTap={() => {
        history.push("/app/video-feed", { model });
      }}
      disabled={!model.isConnected()}
    />
  </CommonControlWrapper>
);

Camera.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
};

export default Camera;



// WEBPACK FOOTER //
// ./src/components/Controls/Camera.jsx